import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[selfFocus]'
})
export class SelfFocusDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.el.nativeElement.focus();
    });
  }
}
